import { render, staticRenderFns } from "./RequireFile.vue?vue&type=template&id=2dec44e4&"
import script from "./RequireFile.vue?vue&type=script&lang=js&"
export * from "./RequireFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports